<chapter-step
  [title]="'Auto-approved based on scheduled hours' | translate"
  [nextButtonLoading]="nextButtonLoading"
  [nextButtonDisabled]="autoApproveHours.value === null"
  (next)="onNext()"
>
  <p class="m-0 text-base">
    {{ 'Auto-approval works best for predictable shifts. Turn off if worked hours often vary from shifts' | translate }}
  </p>
  <sb-radio-group [formControl]="autoApproveHours" class="flex flex-col gap-2">
    @for (option of autoApproveHoursOptions; track option.value) {
      <sb-radio
        class="p-1"
        [name]="'time-tracking-method'"
        [value]="option.value"
        [label]="option.label"
        [description]="option.description"
      />
    }
  </sb-radio-group>
</chapter-step>
